module.exports = __webpack_public_path__ + "img/ic_c@2x.fc620d26.png";